// extracted by mini-css-extract-plugin
module.exports = {"logSelect":"_2myCKRvhvB1MvnTFPjCUEk"};